import { routes } from './fornecedores.routes';
import AtvFornecedoresListController from "./directory/directory.controller";
import AtvFornecedoresDetailsController from "./details/details.controller";
export default angular.module('app.ativos.fornecedores', [])
    .config(routes)
    .controller('AtvFornecedoresListController', AtvFornecedoresListController)
    .controller('AtvFornecedoresDetailsController', AtvFornecedoresDetailsController)
    .name;
